export default "__VITE_ASSET__DTg0FA7l__"